import { forwardRef } from "react";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

import { SWReactIcons } from "@similarweb/icons";
import type { Translatable } from "app/pages/sales-intelligence/types";

import { StyledFilterDropdownButton } from "./styles";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

type Props = {
    isActive?: boolean;
    hasValue?: boolean;
    isDisabled?: boolean;
    children: ReactNode;
    placeholder?: Readonly<Translatable>;
    dataAutomation?: string;
} & Omit<ComponentPropsWithoutRef<"div">, "children">;

const FilterDropdownButton = forwardRef<HTMLDivElement, Props>(function FilterDropdownButton(props, ref) {
    const { children, isActive, isDisabled, hasValue, placeholder, dataAutomation, ...rest } = props;

    return (
        <StyledFilterDropdownButton
            ref={ref}
            isActive={isActive}
            isDisabled={isDisabled}
            withPlaceholder={!hasValue}
            data-automation={dataAutomation}
            {...rest}
        >
            {hasValue || !placeholder ? (
                children
            ) : (
                <I18n
                    translatable={placeholder}
                    data-automation="button-label-placeholder-text"
                />
            )}
            <SWReactIcons iconName="arrow" />
        </StyledFilterDropdownButton>
    );
});

export default FilterDropdownButton;
